export enum PP_RUNNER_MODIFIER_EVENT {
  APPLY_FILTER = "PROGRAM_PAGE_RUNNER_MODIFIER_FILTER_APPLIED",
  APPLY_SORT = "PROGRAM_PAGE_RUNNER_MODIFIER_SORT_APPLIED"
}
